export const getSkillNameAndLevel = (skill, skillLevel) => {
	return `${skill.name} - ${skillLevel?.level || '?'}`;
};
